import axios from 'axios'
import { castAttributesForCamelCase } from '../../../modules/string_converter'

export const companiesCustomSurveySurveys = {
  namespaced: true,
  state: {
    data: [],
    loading: false
  },
  getters: {
    analyzableSurveys(state) {
      return state.data.filter(v => (v.status === 'published' || v.status === 'closed') && v.answerCount !== 0)
    }
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
    },
    apiFailure(state) {
      state.loading = false
    },
    readCustomSurveysSuccess(state, payload) {
      state.data = payload.data.map(v => castAttributesForCamelCase(v))
      state.loading = false
    },
    clearUnreadAnswersCount(state, surveyId) {
      const surveyIndex = state.data.findIndex(survey => survey.id === surveyId)
      state.data[surveyIndex].unreadAnswersCount = 0
    }
  },
  actions: {
    readCustomSurveys({ commit, rootState }) {
      commit('apiConnect')

      return axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/custom_surveys/surveys.json`)
        .then(res => {
          commit('readCustomSurveysSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    clearUnreadAnswersCount({ commit }, surveyId) {
      commit('clearUnreadAnswersCount', surveyId)
    }
  }
}